import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { advancedSearchResultFormSchema } from '../../../helpers/search/advancedSearchResultFormSchema';
import { rootRoute } from '../../../router/routes/rootRoute';

export const advancedSearchResultRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/advanced-search-result',
	validateSearch: advancedSearchResultFormSchema,
	component: lazyRouteComponent(
		() => import('./AdvancedSearchResultPage'),
		'AdvancedSearchResultPage',
	),
});
